if (!window.Eurus.loadedScript.includes('bexit-load-color-picker.js')) {
  window.Eurus.loadedScript.push('bexit-load-color-picker.js')

  requestAnimationFrame(() => {
    document.addEventListener('alpine:init', () => {
      function setInnerHTML(elm, html) {
        elm.innerHTML = html

        Array.from(elm.querySelectorAll('script')).forEach((oldScriptEl) => {
          const newScriptEl = document.createElement('script')

          Array.from(oldScriptEl.attributes).forEach((attr) => {
            newScriptEl.setAttribute(attr.name, attr.value)
          })

          const scriptText = document.createTextNode(oldScriptEl.innerHTML)
          newScriptEl.appendChild(scriptText)

          oldScriptEl.parentNode.replaceChild(newScriptEl, oldScriptEl)
        })
      }

      const constructHtml = (
        colorValue,
        colorMetaobjectId,
        secondaryColorValue,
        secondaryColorMetaobjectId,
        collectionProducts,
        label,
      ) => {
        let selectedColorCode = `${colorMetaobjectId}`
        let selectedColorValue = `${colorValue}`

        if (secondaryColorMetaobjectId && secondaryColorValue) {
          selectedColorCode = selectedColorCode.concat(`-${secondaryColorMetaobjectId}`)
          selectedColorValue = selectedColorValue.concat(`/${secondaryColorValue}`)
        }

        const textHtml = `
          <div id="load-color-picker-constructed-html" class="w-full">
              <span>${label}: <b>${selectedColorValue}</b></span>
              <div class="w-full flex flex-row items-start lg:flex-wrap flex-nowrap mt-2 gap-x-4 whitespace-nowrap lg:whitespace-normal overflow-x-auto hide-scrollbar">
                  ${collectionProducts
                    .map((cp) => {
                      let currentColorCode = `${cp.colorId}`
                      let currentColorValue = `${cp.color}`

                      if (cp.secondaryColorId && cp.secondaryColor) {
                        currentColorCode = currentColorCode.concat(`-${cp.secondaryColorId}`)
                        currentColorValue = currentColorValue.concat(`/${cp.secondaryColor}`)
                      }

                      
                      return `
                      <a href=${cp.url}>
                          <div class="flex flex-col items-start max-w-[80px]">
                              <div style="width:80px; height:100px;" class="flex flex-col items-start cursor-pointer ${
                                currentColorCode === selectedColorCode ? 'border-px' : 'border-fade'
                              }">
                                  <img style="padding: 4px 8px" class="w-full h-full object-contain object-center" src=${
                                    cp.thumbnail
                                  }></img>
                              </div>
                              <span class="text-small break-all mt-1 inline-block whitespace-normal">${currentColorValue}</span>
                          </div>
                      </a>
                  `
                    })
                    .join(' ')}
              </div>
          </div>`

        return textHtml
      }

      const fetchCollectionData = async (fsku) => {
        const url = new URL(`${window.location.origin}${window.Shopify.routes.root}collections/all/${fsku}`)
        url.searchParams.append('view', 'color-picker')

        try {
          const result = await fetch(url).then((r) => {
            if (!r.ok) {
              throw new Error()
            }

            const data = r.json()
            return data
          })

          return result
        } catch (e) {
          console.error(e)
        }
      }

      Alpine.store('bexitColorPicker', {
        async loadColorPicker(
          colorPickerDiv,
          tags,
          label,
          colorValue,
          colorMetaobjectId,
          secondaryColorValue,
          secondaryColorMetaobjectId,
        ) {
          if (colorPickerDiv) {
            const fsku = tags.find((t) => t.startsWith('BEXIT_FSKU'))

            if (fsku) {
              try {
                const result = await fetchCollectionData(fsku)

                if (result) {
                  const { products } = result

                  if (products?.length > 0) {
                    const constructedHtml = constructHtml(
                      colorValue,
                      colorMetaobjectId,
                      secondaryColorValue,
                      secondaryColorMetaobjectId,
                      products,
                      label,
                    )

                    if (constructedHtml) {
                      setInnerHTML(colorPickerDiv, constructedHtml)
                    }
                  }
                } else {
                  colorPickerDiv.style.display = 'none'
                }
              } catch (e) {
                console.error(e)
                colorPickerDiv.style.display = 'none'
              }
            } else {
              colorPickerDiv.style.display = 'none'
            }
          }
        },
      })
    })
  })
}
